<template>
    <div class="w-100">

        <list-container v-if="view.view_type === 'list'" :table="table" :view="view" :show-header="showHeader"></list-container>
        <grid-view v-if="view.view_type === 'grid'" :table="table" :view="view" :show-header="showHeader"></grid-view>

        <gallery-view v-if="view.view_type === 'gallery' && !model.supportMobile" :table="table" :view="view" :show-header="showHeader"></gallery-view>
        <gallery-view-with-mobile v-if="view.view_type === 'gallery' && model.supportMobile" :table="table" :view="view" :show-header="showHeader"></gallery-view-with-mobile>

        <table-view v-if="view.view_type === 'table'" :table="table" :view="view" :show-header="showHeader"></table-view>
        <kanban-board v-if="view.view_type === 'kanban'" :table="table" :view="view" :show-header="showHeader"></kanban-board>
        <form-renderer v-if="view.view_type === 'form'" :table="table" :view="view"></form-renderer>
        <custom-layout-renderer v-if="view.view_type === 'custom'" :table="table" :view="view"></custom-layout-renderer>

        <div v-if="view.view_type === 'details'">

            <view-header :table="table" :view="view"></view-header>

            <div class="m-2">
                No records have been found for this view.
            </div>

        </div>
    </div>
</template>

<script>
    import ListView from "../list/ListView.vue";
    import GalleryView from "../gallery/GalleryView.vue";
    import TableView from "../table/TableView.vue";
    import CustomLayoutRenderer from "../layout/CustomLayoutRenderer.vue";
    import FormRenderer from "../form/FormRenderer.vue";
    import KanbanBoard from "../kanban/KanbanBoard.vue";
    import GridView from "../grid/GridView.vue";
    import ViewHeader from "../ViewHeader.vue";
    import GalleryViewWithMobile from "../gallery/GalleryViewWithMobile.vue";
    import ListContainer from "../list/ListContainer.vue";
    export default {
        name: 'ViewRenderer',
        components: {
            ListContainer,
            GalleryViewWithMobile,
            ViewHeader,
            GridView, KanbanBoard, FormRenderer, CustomLayoutRenderer, TableView, GalleryView, ListView},
        props: {
            view: Object,
            table: Object,
            showHeader: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                model: webase.model
            }
        }
    }
</script>

<style>

</style>
